import { DisputeStatuses } from '@Constants';
import { IConsumerProductDispute } from 'src/gql';

export const hasUnresolvedPaymentProtectionDispute: (disputes: Array<Partial<IConsumerProductDispute> | null>) => boolean
  = disputes =>
    disputes.some(dispute =>
      dispute && dispute.status !== DisputeStatuses.Closed && dispute.is_payment_protection_applied
    );
